import { AnimatePresence, motion } from 'framer-motion'

interface AccordionTransitionProps {
    open: boolean
    children: React.ReactNode
}

export function AccordionTransition({
    open,
    children,
}: AccordionTransitionProps) {
    return (
        <AnimatePresence initial={false}>
            {open && (
                <motion.div
                    initial={{ gridTemplateRows: '0fr' }}
                    animate={{ gridTemplateRows: '1fr' }}
                    exit={{ gridTemplateRows: '0fr' }}
                    transition={{
                        duration: 0.2,
                    }}
                    style={{ overflow: 'clip', display: 'grid' }}
                >
                    <div style={{ overflow: 'hidden' }}>{children}</div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
